/**
 * DecodeEntities
 *
 * Converts html entities to normal characters and cleans up double encoded fings too!
 */
export default (string) => {
    if (typeof string === 'undefined' || string === null) {
        return string;
    }

    const textArea = document.createElement('textarea');
    textArea.innerHTML = string
        .replace(/&amp;(?:amp;)+/g, '&amp;') // convert multiple encoded ampersands
        .replace(/&amp;([a-z0-9_#-]+);/g, '&$1;'); // convert double encoded stuff

    return textArea.value;
};
